import type { CommonSVGProps } from './helpers';

export const TaskIconActive = (props: CommonSVGProps) => {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect fill="#292929" height="14" rx="2" stroke="#292929" strokeWidth="2" width="14" x="8" y="8" />
      <path
        d="M5 16H4C2.89543 16 2 15.1046 2 14V4C2 2.89543 2.89543 2 4 2H14C15.1046 2 16 2.89543 16 4V4.5"
        stroke="#292929"
        strokeLinecap="round"
        strokeWidth="2"
      />
    </svg>
  );
};
